import Vue from 'vue'
import { AxiosError, AxiosResponse } from 'axios'

const taskRelations = ['category','team_users', 'elements']

const needFetchTask = (task: KwixeoTasks.Task): boolean => {
  return !taskRelations.every(relation => relation in task)
}

const fetchTask = async (id: number|string): Promise<KwixeoTasks.Task> => {
  return await Vue.prototype.$kwTasks.axios.get('/task/' + id, {
      params: {
        include: taskRelations.join(',')
      }
    })
    .then((response: AxiosResponse) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      throw new Error((error.response as AxiosResponse)?.data)
    })
}

export {
  taskRelations, needFetchTask, fetchTask
}
